import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar_old";
import Footer from "./Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import apiService from "../services/apiService";
import DataTable from "react-data-table-component";

const Dashboard = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [formData, setFormData] = useState({});
  const [search, setSearch] = useState("");

  // ================= FETCH USERS =================
  const fetchUsers = () => {
    setLoading(true);
    apiService.getAllUsers()
      .then((data) => {
        setUsers(data.users || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // ================= DELETE =================
  const handleDelete = (id) => {
    if (!window.confirm("Delete this user?")) return;
    apiService.deleteUser(id)
      .then(() => fetchUsers());
  };

  // ================= STATUS =================
  const toggleStatus = (user) => {
    const newStatus = user.status === "Active" ? "Inactive" : "Active";
    apiService.updateUserStatus(user._id, newStatus)
      .then(() => fetchUsers());
  };

  // ================= PERMISSION =================
  const handlePermissionToggle = (id, field, value) => {
    apiService.updatePermission(id, field, value)
      .then(() => fetchUsers());
  };

  // ================= EDIT =================
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files && files[0]) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSave = () => {
    const data = new FormData();

    Object.keys(formData).forEach((key) => {
      if (formData[key] !== null && formData[key] !== undefined) {
        data.append(key, formData[key]);
      }
    });

    apiService.updateUser(selectedUser._id, data)
      .then(() => {
        alert("Updated successfully");
        setSelectedUser(null);
        fetchUsers();
      });
  };

  // ================= SEARCH =================
  const filteredUsers = users.filter(
    (u) =>
      (u.full_name || "").toLowerCase().includes(search.toLowerCase()) ||
      (u._id || "").includes(search) ||
      (u.mobile || "").includes(search) ||
      (u.gender || "").toLowerCase().includes(search.toLowerCase()) ||
      (u.user_state || "").toLowerCase().includes(search.toLowerCase())
  );

  const allFields = [
    "full_name","username","email","password","mobile","user_state","city",
    "pincode","gender","marital_status","age","height","weight","color","diet",
    "disability","blood_group","education","education_detail","profession",
    "occupation","occupation_detail","income","father_name","father_occupation",
    "mother_name","mother_occupation","married_brothers","unmarried_brothers",
    "married_sisters","unmarried_sisters","maternal_uncle_name",
    "maternal_uncle_gotra","gotra","subcaste","mother_tongue","dob","tob","pob",
    "zodiac","manglik","nakshatra","house","car","profile_created_by","country",
    "town","whatsapp","father_contact","email_contact","present_address",
    "permanent_address","image"
  ];

  useEffect(() => {
    if (selectedUser) setFormData({ ...selectedUser });
  }, [selectedUser]);

  // ================= COLUMNS FOR DATA TABLE =================
 const columns = [
  {
    name: "ID",
    selector: (row) => row._id.slice(-6),
    sortable: true,
    width: "80px",
  },
  {
    name: "Image",
    cell: (row) => {
      const imageUrl = row.image
        ? row.image.startsWith("http")
          ? row.image
          : `${apiService.getBaseUrl()}${row.image.startsWith("/") ? "" : "/"}${row.image}`
        : "https://i.pravatar.cc/40?img=12";

      return (
        <img
          src={imageUrl}
          alt="user"
          width="40"
          height="40"
          style={{ borderRadius: "50%", objectFit: "cover" }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "https://i.pravatar.cc/40?img=12";
          }}
        />
      );
    },
    width: "60px",
  },
  { name: "Name", selector: (row) => row.full_name, sortable: true },
  { name: "Email", selector: (row) => row.email, sortable: true },
  { name: "Mobile", selector: (row) => row.mobile, sortable: true },
  { name: "Gender", selector: (row) => row.gender, sortable: true },
  { name: "State", selector: (row) => row.user_state, sortable: true },
  {
    name: "Status",
    cell: (row) => (
      <button
        className={`btn btn-sm ${
          row.status === "Active" ? "btn-success" : "btn-secondary"
        }`}
        onClick={() => toggleStatus(row)}
      >
        {row.status}
      </button>
    ),
  },
  {
    name: "Chat",
    cell: (row) => (
      <span
        style={{ cursor: "pointer" }}
        onClick={() =>
          handlePermissionToggle(row._id, "can_chat", !row.can_chat)
        }
      >
        {row.can_chat ? "✅" : "❌"}
      </span>
    ),
  },
  {
    name: "Call",
    cell: (row) => (
      <span
        style={{ cursor: "pointer" }}
        onClick={() =>
          handlePermissionToggle(row._id, "can_call", !row.can_call)
        }
      >
        {row.can_call ? "✅" : "❌"}
      </span>
    ),
  },
  {
    name: "Action",
    cell: (row) => (
      <div className="d-flex justify-content-center gap-1">
        <button
          className="btn btn-warning btn-sm"
          data-bs-toggle="modal"
          data-bs-target="#editModal"
          onClick={() => setSelectedUser(row)}
        >
          Edit
        </button>
        <button
          className="btn btn-danger btn-sm"
          onClick={() => handleDelete(row._id)}
        >
          Delete
        </button>
      </div>
    ),
  },
];


  return (
    <div className="container-fluid py-4 bg-light min-vh-100">
      <div className="container bg-white p-4 rounded shadow">

        {/* SEARCH */}
        <input
          className="form-control mb-3"
          placeholder="Search by name, ID, mobile, gender, state..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {/* DATA TABLE */}
        <DataTable
          title="Users Dashboard"
          columns={columns}
          data={filteredUsers}
          progressPending={loading}
          pagination
          highlightOnHover
          responsive
          striped
          dense
        />
      </div>

      {/* MODAL */}
      <div className="modal fade" id="editModal">
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-body">
              {allFields.map((f) => (
                <input
                  key={f}
                  name={f}
                  placeholder={f}
                  className="form-control mb-2"
                  type={f === "image" ? "file" : "text"}
                  value={f === "image" ? undefined : formData[f] || ""}
                  onChange={handleChange}
                />
              ))}
              <button className="btn btn-success" onClick={handleSave}>
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Dashboard;
